import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=16661c5f&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16661c5f')) {
      api.createRecord('16661c5f', component.options)
    } else {
      api.reload('16661c5f', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=16661c5f&", function () {
      api.rerender('16661c5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/newsletter/group/Index.vue"
export default component.exports